import { useState } from 'react';

import { TextField } from '@mui/material';

import StepScreen from '@/karehero-app/access/StepScreen';
import { type Account } from '@/karehero-app/access/AccountBar';

// Work path of the access flow: just the work email, since the member
// already told us how their access is funded. The escape hatches (payroll
// ID, sign in instead) live on the code screen, where things actually go
// wrong: no code arrives, or the email says you already have an account.
const WorkEmailScreen = ({
  onSubmit,
  onBack,
  error,
  account,
}: {
  onSubmit: (email: string) => void;
  onBack: () => void;
  /** What the check said, under the field. See ACCESS_ERRORS. */
  error?: string;
  /** The app bar and its account sheet. See StepScreen. */
  account?: Account;
}) => {
  const [email, setEmail] = useState('');

  return (
    <StepScreen
      title="What's your work email?"
      description='We use this to confirm your company benefit.'
      primaryLabel='Continue'
      onPrimary={() => onSubmit(email.trim())}
      onBack={onBack}
      account={account}
    >
      <TextField
        slotProps={{ inputLabel: { shrink: true } }}
        label='Work email address'
        placeholder='example@company.com'
        variant='filled'
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        error={Boolean(error)}
        helperText={error ?? 'Use the email address provided by your employer.'}
        fullWidth
      />
    </StepScreen>
  );
};

export default WorkEmailScreen;
